import { useLocalization } from "../contexts/LocalizationContext";

export const translateDictionaryValues = (headers: { headerKey: string; label: string }[]) => {
    const localized = useLocalization(); 
  
    return headers.map(header => ({
      ...header,
      label: (localized as Record<string, string>)[header.label] || header.label,
    }));
  };